var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"width":"800px"},on:{"close":function($event){return _vm.closeModal()}}},[_c('request-access-form',{on:{"closeModal":_vm.closeModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }